<template>
  <LessonElementExecution v-if="element.elementType === 1" :element="element" :course-id="courseId" />
  <VideoElementExecution v-else-if="element.elementType === 2" :element="element" :course-id="courseId" />
  <MeetingElementExecution v-else-if="element.elementType === 4" :element="element" :course-id="courseId" />
</template>

<script>
import LessonElementExecution from '@/components/course/element/LessonElementExecution.vue';
import VideoElementExecution from '@/components/course/element/VideoElementExecution.vue';
import MeetingElementExecution from '@/components/course/element/MeetingElementExecution.vue';

export default {
  components: {
    LessonElementExecution,
    VideoElementExecution,
    MeetingElementExecution
  },
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  computed: {
    courseId() {
      return Number(this.$route.params.courseId);
    }
  }
};
</script>
